// import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import Select from 'react-select';
// import SweetAlert from '../Shared/Notification';
// import OptionModal from '../Modals/OptionModal';
// import './index.css';
// import { useNavigate, useParams } from 'react-router-dom';
// import APIService from '../../Services/APIService';
// import { Form, Table, Button, Modal } from 'react-bootstrap'
// import SelectDropdown from '../Shared/SelectDropdown';

// const CreateChecklistTemplate = () => {
//   const navigate = useNavigate();
//   const { campaignId, supplierId } = useParams();
//   const [templateList, setTemplateList] = useState([])
//   // Get column option from string

//   const MAX_COLUMNS = 100;
//   const ColumnTypes = [
//     { value: 'TEXT', label: 'Textbox' },
//     { value: 'BOOLEAN', label: 'Checkbox' },
//     { value: 'DATETIME', label: 'Date Time' },
//     { value: 'RATING', label: 'Rating' },
//     { value: 'NUMBER', label: 'Number' },
//     { value: 'EMAIL', label: 'Email' },
//     { value: 'RADIO', label: 'Radio' },
//     { value: 'SELECT', label: 'Select' },
//   ];
//   const getColumnOption = (value) => {
//     for (let i = 0, l = ColumnTypes.length; i < l; i += 1) {
//       if (ColumnTypes[i].value === value) {
//         return ColumnTypes[i];
//       }
//     }
//     return { value };
//   };

//   const getDefaultColumns = () => {
//     return [
//       {
//         column_name: '',
//         column_type: getColumnOption('TEXT'),
//         order_id: 1,
//       },
//       {
//         column_name: '',
//         column_type: getColumnOption('TEXT'),
//         order_id: 2,
//       },
//     ];
//   };
//   const [state, setState] = useState({
//     checklist_type: 'supplier',
//     checklist_name: '',
//     is_template: 'false',
//     checklist_columns: getDefaultColumns(),
//     showOptionModal: false,
//     columnOptions: [''],
//     columnInfo: {},
//     static_column_values: {
//       '1': [
//         {
//           row_id: 1,
//           cell_value: '',
//           disabled: false,
//         },
//       ],
//       '2': [
//         {
//           row_id: 1,
//           cell_value: '',
//           disabled: true,
//         },
//       ],
//     },
//     existingChecklistOptions: [],
//     selectedChecklist: {},
//     isMaxColumnsReached: false,
//   })





//   const getChecklistTemplate = async () => {
//     let res = await APIService.get(`/v0/ui/checklists/list_all_checklists_templates/`);
//     if (res.status == 200) {
//       console.log('list_all_checklists_templates-------', res.data, '----------list_all_checklists_templates')
//       setTemplateList(res.data)
//       // let checklistOptions = [];
//       // this.props.checklist.templateList.forEach((checklist) => {
//       //   checklistOptions.push({
//       //     value: checklist.checklist_info.checklist_id,
//       //     label: checklist.checklist_info.checklist_name,
//       //   });
//       // });
//       // setState({
//       //   ...state,
//       //   existingChecklistOptions: checklistOptions,
//       // });
//       // }
//     }
//   };

//   useEffect(() => {
//     if (!supplierId) {
//       setState({
//         ...state,
//         checklist_type: 'campaign',
//       });
//     }
//     getChecklistTemplate();

//   }, [])

//   const onBack = () => {
//     if (state.checklist_type === 'supplier') {
//       navigate(`/r/checklist/list/${campaignId}/${supplierId}`);
//     } else {
//       navigate(`/r/checklist/list/${campaignId}`);
//     }
//   }

//   const handleInputChange = (e) => {
//     if (e.target.type === 'checkbox') {
//       e.target.value = e.target.checked ? true : false;
//     }
//     setState({
//       ...state,
//       [e.target.name]: e.target.value,
//     });
//   }

//   const handleColumnChange = (column, index) => {
//     let stateData = { ...state };
//     const checklistColumns = stateData.checklist_columns.slice();
//     checklistColumns.splice(index, 1, column);

//     setState({
//       ...state,
//       checklist_columns: checklistColumns,
//     });
//   }

//   const handleRowChange = (event, columnIndex, rowIndex) => {
//     let stateData = { ...state };
//     let rows = Object.assign({}, stateData.static_column_values);

//     rows[columnIndex + 1][rowIndex].cell_value = event.target.value;
//     setState({
//       ...state,
//       static_column_values: rows,
//     });
//   }

//   const onAddRow = () => {
//     let stateData = { ...state };
//     const rows = Object.assign({}, stateData.static_column_values);
//     let columnLength = Object.values(rows).length;
//     let rowLength = rows['1'].length;
//     for (let i = 0; i < columnLength; i++) {
//       rows[i + 1].push({
//         row_id: rowLength + 1,
//         cell_value: '',
//         disabled: i === 0 ? false : true,
//       });
//     }
//     setState({
//       ...state,
//       static_column_values: rows,
//     });
//   }

//   const onAddColumn = () => {
//     let steteData = { ...state };
//     const checklistColumns = steteData.checklist_columns.slice();
//     if (checklistColumns.length < MAX_COLUMNS) {
//       const rows = Object.assign({}, steteData.static_column_values);
//       for (let i = 0; i < rows['1'].length; i++) {
//         if (rows[checklistColumns.length + 1]) {
//           rows[checklistColumns.length + 1].push({
//             row_id: i + 1,
//             cell_value: '',
//             disabled: true,
//           });
//         } else {
//           rows[checklistColumns.length + 1] = [
//             {
//               row_id: i + 1,
//               cell_value: '',
//               disabled: true,
//             },
//           ];
//         }
//       }
//       checklistColumns.push({
//         column_name: '',
//         column_type: 'TEXT',
//         order_id: checklistColumns.length + 1,
//       });
//       setState({
//         ...state,
//         static_column_values: rows,
//         checklist_columns: checklistColumns,
//       });
//     } else {
//       setState({
//         ...state,
//         isMaxColumnsReached: true,
//       });
//     }
//   }

//   const onRowRemove = (index) => {
//     let stateData = { ...state }
//     const rows = Object.assign({}, stateData.static_column_values);
//     for (let i = 0; i < Object.values(rows).length; i++) {
//       rows[i + 1].splice(index, 1);
//       for (let j = 0; j < rows[i + 1].length; j++) {
//         rows[i + 1][j].row_id = j + 1;
//       }
//     }
//     setState({
//       ...state,
//       static_column_values: rows,
//     });
//   }

//   const onColumnRemove = (index) => {
//     let stateData = { ...state };
//     const rows = stateData.static_column_values;
//     const checklistColumns = stateData.checklist_columns.slice();
//     checklistColumns.splice(index, 1);
//     if (!checklistColumns.length) {
//       checklistColumns.concat(getDefaultColumns());
//     }
//     for (let i = index + 1; i <= Object.values(rows).length; i++) {
//       rows[i] = rows[i + 1];
//     }
//     delete rows[Object.values(rows).length];
//     for (let i = 0; i < checklistColumns.length; i++) {
//       checklistColumns[i].order_id = i + 1;
//     }

//     setState({
//       ...state,
//       checklist_columns: checklistColumns,
//       static_column_values: rows,
//     });
//   }

//   const onOpenOptionModal = (options, columnType, column, columnIndex) => {
//     setState({
//       ...state,
//       showOptionModal: true,
//       columnOptions: options,
//       columnInfo: {
//         columnType,
//         column,
//         columnIndex,
//       },
//     });
//   }

//   const onCancelOptionModal = () => {
//     setState({
//       ...state,
//       showOptionModal: false,
//       columnOptions: [''],
//       columnInfo: {},
//     });
//   }

//   const onSubmitOptionModal = (options, columnInfo) => {
//     setState({
//       ...state,
//       showOptionModal: false,
//       columnOptions: [''],
//       columnInfo: {},
//     });

//     let newColumn = Object.assign({}, columnInfo.column, {
//       column_type: columnInfo.columnType,
//       column_options: options,
//     });
//     handleColumnChange(newColumn, columnInfo.columnIndex);
//   }

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     let stateData = { ...state };
//     let error = false;
//     let checklist_columns = stateData.checklist_columns;
//     checklist_columns.forEach((item) => {
//       if (typeof item.column_type !== 'string') {
//         item.column_type = item.column_type.value;
//       }
//     });

//     let staticRowData = Object.assign({}, stateData.static_column_values),
//       staticDataError = false;
//     let staticRowKeys = Object.keys(staticRowData);

//     staticRowKeys.forEach((i) => {
//       staticRowData[i] = staticRowData[i].filter((staticData) => {
//         if (staticData.disabled) {
//           return false;
//         } else {
//           if (staticData.cell_value === '') {
//             staticDataError = true;
//           } else {
//             delete staticData.disabled;
//           }
//           return true;
//         }
//       });

//       if (!staticRowData[i].length) {
//         delete staticRowData[i];
//       }
//     });

//     if (staticDataError) {
//       SweetAlert('Please fill all the static data input field', 'error');
//       return;
//     }

//     const data = {
//       checklist_name: stateData.checklist_name,
//       checklist_type: stateData.checklist_type,
//       supplier_id: supplierId,
//       is_template: stateData.is_template === 'true' ? true : false,
//       checklist_columns,
//       static_column_values: staticRowData,
//     };

//     data.checklist_columns.forEach((column) => {
//       if (!column.column_type) {
//         error = true;
//         SweetAlert('Please select column type for each column', 'error');
//         return false;
//       }
//     });

//     if (error) {
//       return;
//     }
//     let res = await APIService.post(`/v0/ui/checklists/${campaignId}/create`, data);
//     if (res.status == 200) {
//       // Send request to create template
//       SweetAlert('Checklist created successfully', 'success');
//       onBack()
//     } else {
//       SweetAlert('Booking Template updated successfully', 'success');
//     }
//   }

//   const handleStaticColumnChange = (event, columnIndex) => {
//     let rows = Object.assign({}, state.static_column_values);
//     for (let i = 0; i < rows[columnIndex + 1].length; i++) {
//       rows[columnIndex + 1][i].disabled = !event.target.checked;
//     }
//     setState({
//       ...state,
//       static_column_values: rows,
//     });
//   }

//   const renderChecklistColumn = (column, columnIndex) => {
//     const onColumnNameChange = (event) => {
//       const newColumn = Object.assign({}, column, {
//         column_name: event.target.value,
//       });
//       handleColumnChange(newColumn, columnIndex);
//     };

//     const onColumnTypeChange = (item) => {
//       if (item.value !== 'TEXT') {
//         let rows = Object.assign({}, state.static_column_values);
//         if (rows[columnIndex + 1][0].disabled === false) {
//           SweetAlert('Cannot change type for Static Columns', 'error');
//           return;
//         }
//       }
//       if (item.value === 'RADIO' || item.value === 'SELECT') {
//         setState({
//           ...state,
//           showOptionModal: true,
//           columnOptions: [''],
//           columnInfo: {
//             columnType: item,
//             column,
//             columnIndex,
//           },
//         });
//         return;
//       }
//       const newColumn = Object.assign({}, column, {
//         column_type: item,
//       });
//       handleColumnChange(newColumn, columnIndex);
//     };
//     const onRemove = () => {
//       onColumnRemove(columnIndex);
//     };

//     return (
//       <div className="createform__form__column" key={`col-${columnIndex}`}>
//         <div className="createform__form__inline column-data">
//           <div className="form-control">
//             <div>
//               <input
//                 type="text"
//                 placeholder="Column Name"
//                 value={column.column_name}
//                 onChange={(e) => onColumnNameChange(e)}
//               />
//               <Select
//                 options={ColumnTypes}
//                 classNamePrefix="form-select"
//                 value={
//                   typeof column.column_type === 'object'
//                     ? column.column_type
//                     : getColumnOption(column.column_type)
//                 }
//                 onChange={(e) => onColumnTypeChange(e)}
//               />
//               <div>
//                 {columnIndex > 1 ? (
//                   <Button type="button" className="btn btn--danger" onClick={onRemove}>
//                     Remove column
//                   </Button>
//                 ) : (
//                   undefined
//                 )}{' '}
//                 {column.column_type &&
//                   (column.column_type.value === 'RADIO' || column.column_type.value === 'SELECT') ? (
//                   <Button
//                     type="button"
//                     className="btn btn--danger"
//                     onClick={() =>
//                       onOpenOptionModal(
//                         column.column_options,
//                         column.column_type,
//                         column,
//                         columnIndex
//                       )
//                     }
//                   >
//                     Show Options
//                   </Button>
//                 ) : (
//                   undefined
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const handleSelectChecklist = (selectedChecklist) => {
//     setState({
//       ...state,
//       selectedChecklist,
//     });

//     // let { checklist } = this.props;

//     // checklist.templateList.forEach((checklist) => {
//     //   if (checklist.checklist_info.checklist_id === selectedChecklist.value) {
//     //     setState({
//     //       ...state,
//     //       checklist_columns: checklist.column_headers,
//     //       static_column_values: checklist.row_headers,
//     //     });
//     //     return;
//     //   }
//     // });
//   }

//   const renderChecklistRow = (row, rowIndex) => {
//     const onRemove = () => {
//       onRowRemove(rowIndex);
//     };
//     let static_value = Object.assign({}, state.static_column_values);

//     return (
//       <div className="createform__form__row" key={`row-${rowIndex}`}>
//         {state.checklist_columns.map((column, columnIndex) => {
//           return (
//             <div className="createform__form__column" key={`row-${rowIndex}-column-${columnIndex}`}>
//               <div className="createform__form__inline">
//                 <div className="form-control">
//                   <input
//                     type="text"
//                     placeholder="Static Data"
//                     value={
//                       static_value[columnIndex + 1] && static_value[columnIndex + 1][rowIndex]
//                         ? static_value[columnIndex + 1][rowIndex].cell_value
//                         : ''
//                     }
//                     onChange={(event) => handleRowChange(event, columnIndex, rowIndex)}
//                     disabled={
//                       static_value[columnIndex + 1] && static_value[columnIndex + 1][rowIndex]
//                         ? static_value[columnIndex + 1][rowIndex].disabled
//                         : true
//                     }
//                   />
//                   {columnIndex !== 0 ? (
//                     <div className="checkbox-data">
//                       <input
//                         className="input-checkbox"
//                         type="checkbox"
//                         onClick={(event) => handleStaticColumnChange(event, columnIndex)}
//                       />
//                       <p className="main-text">
//                         Static Data
//                         <em>(Field entered in static column cannot be changed later)</em>
//                       </p>
//                     </div>
//                   ) : (
//                     undefined
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//         {rowIndex > 0 ? (
//           <div className="form-action">
//             <Button type="button" className="btn btn--link" onClick={onRemove}>
//               &times;
//             </Button>
//           </div>
//         ) : (
//           ''
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="createform">
//       <div className="createform__title">
//         <h3>Create Checklist Form</h3>
//       </div>
//       <div className="createform__form" style={{ overflowX: 'scroll' }}>
//         <Form onSubmit={onSubmit}>
//           <div className="createform__form__inline">
//             <div className="form-control">
//               <Form.Label>Select from existing checklist templateType <span className="required-field">*</span></Form.Label>
//               <Select
//                 options={state.existingChecklistOptions}
//                 Value={state.selectedChecklist}
//                 onChange={(e) => handleSelectChecklist(e)}
//               />
//             </div>
//           </div>
//           <div className="createform__form__inline">
//             <div className="form-control">
//               <Form.Label>Enter Name For Checklist FormType <span className="required-field">*</span></Form.Label>
//               <input
//                 type="text"
//                 name="checklist_name"
//                 value={state.checklist_name}
//                 onChange={(e) => handleInputChange(e)}
//               />
//             </div>
//           </div>
//           <table>
//             <tbody>
//               <tr>
//                 <td>
//                   <input
//                     type="checkbox"
//                     className="input-checkbox"
//                     name="is_template"
//                     value={state.is_template}
//                     onChange={(e) => handleInputChange(e)}
//                   />
//                 </td>
//                 <td>Is it template?</td>
//               </tr>
//             </tbody>
//           </table>
//           <div className="createform__form__header">
//             {state.checklist_columns.map(renderChecklistColumn)}
//           </div>
//           {state.static_column_values['1'].map(renderChecklistRow)}
//           <div className="createform__form__inline">
//             <div className="createform__form__action">
//               <Button type="button" className="btn btn--danger" onClick={onAddRow}>
//                 Add Row
//               </Button>
//             </div>
//             <div className="createform__form__action">
//               <Button
//                 type="button"
//                 className="btn btn--danger"
//                 onClick={onAddColumn}
//                 disabled={state.isMaxColumnsReached}
//               >
//                 Add Column
//               </Button>
//             </div>
//             <div className="createform__form__action">
//               <Button type="submit" className="btn btn--danger">
//                 Submit
//               </Button>
//             </div>
//             <div className="createform__form__action">
//               <Button type="button" className="btn btn--danger" onClick={onBack}>
//                 Back
//               </Button>
//             </div>
//           </div>
//           {state.isMaxColumnsReached ? (
//             <p className="message message--error">
//               Sorry! You can add a maximum of {MAX_COLUMNS} columns
//             </p>
//           ) : (
//             undefined
//           )}
//         </Form>
//       </div>
//       <OptionModal
//         showOptionModal={state.showOptionModal}
//         onCancel={onCancelOptionModal}
//         onSubmit={onSubmitOptionModal}
//         options={state.columnOptions}
//         columnInfo={state.columnInfo}
//       />
//     </div>
//   );
// }
// export default CreateChecklistTemplate;






import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import SweetAlert from '../Shared/Notification';
import OptionModal from '../Modals/OptionModal';
import './index.css';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../Services/APIService';
import SelectDropdown from '../Shared/SelectDropdown';
import { Box, Button, Checkbox, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, TextField, Typography } from '@mui/material';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import CloseIcon from '@mui/icons-material/Close';

const CreateChecklistTemplate = () => {
  const navigate = useNavigate();
  const { campaignId, supplierId } = useParams();
  const [templateList, setTemplateList] = useState([])

  const MAX_COLUMNS = 100;
  const ColumnTypes = [
    { value: 'TEXT', label: 'Textbox' },
    { value: 'BOOLEAN', label: 'Checkbox' },
    { value: 'DATETIME', label: 'Date Time' },
    { value: 'RATING', label: 'Rating' },
    { value: 'NUMBER', label: 'Number' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'RADIO', label: 'Radio' },
    { value: 'SELECT', label: 'Select' },
  ];
  const getColumnOption = (value) => {
    for (let i = 0, l = ColumnTypes.length; i < l; i += 1) {
      if (ColumnTypes[i].value === value) {
        return ColumnTypes[i];
      }
    }
    return { value };
  };

  const getDefaultColumns = () => {
    return [
      {
        column_name: '',
        column_type: getColumnOption('TEXT'),
        order_id: 1,
      },
      {
        column_name: '',
        column_type: getColumnOption('TEXT'),
        order_id: 2,
      },
    ];
  };
  const [state, setState] = useState({
    checklist_type: 'supplier',
    checklist_name: '',
    is_template: false,
    checklist_columns: getDefaultColumns(),
    showOptionModal: false,
    columnOptions: [''],
    columnInfo: {},
    static_column_values: {
      '1': [
        {
          row_id: 1,
          cell_value: '',
          disabled: false,
        },
      ],
      '2': [
        {
          row_id: 1,
          cell_value: '',
          disabled: true,
        },
      ],
    },
    existingChecklistOptions: [],
    selectedChecklist: {},
    isMaxColumnsReached: false,
  })

  const getChecklistTemplate = async () => {
    let res = await APIService.get(`/v0/ui/checklists/list_all_checklists_templates/`);
    if (res.status == 200) {
      console.log('list_all_checklists_templates-------', res.data, '----------list_all_checklists_templates')
      setTemplateList(res.data)
      // let checklistOptions = [];
      // this.props.checklist.templateList.forEach((checklist) => {
      //   checklistOptions.push({
      //     value: checklist.checklist_info.checklist_id,
      //     label: checklist.checklist_info.checklist_name,
      //   });
      // });
      // setState({
      //   ...state,
      //   existingChecklistOptions: checklistOptions,
      // });
      // }
    }
  };

  useEffect(() => {
    if (!supplierId) {
      setState({
        ...state,
        checklist_type: 'campaign',
      });
    }
    getChecklistTemplate();

  }, [])

  const onBack = () => {
    if (state.checklist_type === 'supplier') {
      navigate(`/r/checklist/list/${campaignId}/${supplierId}`);
    } else {
      navigate(`/r/checklist/list/${campaignId}`);
    }
  }

  const handleInputChange = (e) => {
    const { name, type, value, checked } = e.target;

    setState((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleColumnChange = (column, index) => {
    let stateData = { ...state };
    const checklistColumns = stateData.checklist_columns.slice();
    checklistColumns.splice(index, 1, column);

    setState({
      ...state,
      checklist_columns: checklistColumns,
    });
  }

  const handleRowChange = (event, columnIndex, rowIndex) => {
    let stateData = { ...state };
    let rows = Object.assign({}, stateData.static_column_values);

    rows[columnIndex + 1][rowIndex].cell_value = event.target.value;
    setState({
      ...state,
      static_column_values: rows,
    });
  }

  const onAddRow = () => {
    let stateData = { ...state };
    const rows = Object.assign({}, stateData.static_column_values);
    let columnLength = Object.values(rows).length;
    let rowLength = rows['1'].length;
    for (let i = 0; i < columnLength; i++) {
      rows[i + 1].push({
        row_id: rowLength + 1,
        cell_value: '',
        disabled: i === 0 ? false : true,
      });
    }
    setState({
      ...state,
      static_column_values: rows,
    });
  }

  const onAddColumn = () => {
    let steteData = { ...state };
    const checklistColumns = steteData.checklist_columns.slice();
    if (checklistColumns.length < MAX_COLUMNS) {
      const rows = Object.assign({}, steteData.static_column_values);
      for (let i = 0; i < rows['1'].length; i++) {
        if (rows[checklistColumns.length + 1]) {
          rows[checklistColumns.length + 1].push({
            row_id: i + 1,
            cell_value: '',
            disabled: true,
          });
        } else {
          rows[checklistColumns.length + 1] = [
            {
              row_id: i + 1,
              cell_value: '',
              disabled: true,
            },
          ];
        }
      }
      checklistColumns.push({
        column_name: '',
        column_type: 'TEXT',
        order_id: checklistColumns.length + 1,
      });
      setState({
        ...state,
        static_column_values: rows,
        checklist_columns: checklistColumns,
      });
    } else {
      setState({
        ...state,
        isMaxColumnsReached: true,
      });
    }
  }

  const onRowRemove = (index) => {
    let stateData = { ...state }
    const rows = Object.assign({}, stateData.static_column_values);
    for (let i = 0; i < Object.values(rows).length; i++) {
      rows[i + 1].splice(index, 1);
      for (let j = 0; j < rows[i + 1].length; j++) {
        rows[i + 1][j].row_id = j + 1;
      }
    }
    setState({
      ...state,
      static_column_values: rows,
    });
  }

  const onColumnRemove = (index) => {
    let stateData = { ...state };
    const rows = stateData.static_column_values;
    const checklistColumns = stateData.checklist_columns.slice();
    checklistColumns.splice(index, 1);
    if (!checklistColumns.length) {
      checklistColumns.concat(getDefaultColumns());
    }
    for (let i = index + 1; i <= Object.values(rows).length; i++) {
      rows[i] = rows[i + 1];
    }
    delete rows[Object.values(rows).length];
    for (let i = 0; i < checklistColumns.length; i++) {
      checklistColumns[i].order_id = i + 1;
    }

    setState({
      ...state,
      checklist_columns: checklistColumns,
      static_column_values: rows,
    });
  }

  const onOpenOptionModal = (options, columnType, column, columnIndex) => {
    setState({
      ...state,
      showOptionModal: true,
      columnOptions: options,
      columnInfo: {
        columnType,
        column,
        columnIndex,
      },
    });
  }

  const onCancelOptionModal = () => {
    setState({
      ...state,
      showOptionModal: false,
      columnOptions: [''],
      columnInfo: {},
    });
  }

  const onSubmitOptionModal = (options, columnInfo) => {
    setState({
      ...state,
      showOptionModal: false,
      columnOptions: [''],
      columnInfo: {},
    });

    let newColumn = Object.assign({}, columnInfo.column, {
      column_type: columnInfo.columnType,
      column_options: options,
    });
    handleColumnChange(newColumn, columnInfo.columnIndex);
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    let stateData = { ...state };
    let error = false;
    let checklist_columns = stateData.checklist_columns;
    checklist_columns.forEach((item) => {
      if (typeof item.column_type !== 'string') {
        item.column_type = item.column_type.value;
      }
    });

    let staticRowData = Object.assign({}, stateData.static_column_values),
      staticDataError = false;
    let staticRowKeys = Object.keys(staticRowData);

    staticRowKeys.forEach((i) => {
      staticRowData[i] = staticRowData[i].filter((staticData) => {
        if (staticData.disabled) {
          return false;
        } else {
          if (staticData.cell_value === '') {
            staticDataError = true;
          } else {
            delete staticData.disabled;
          }
          return true;
        }
      });

      if (!staticRowData[i].length) {
        delete staticRowData[i];
      }
    });

    if (staticDataError) {
      SweetAlert('Please fill all the static data input field', 'error');
      return;
    }

    const data = {
      checklist_name: stateData.checklist_name,
      checklist_type: stateData.checklist_type,
      supplier_id: supplierId,
      is_template: stateData.is_template === 'true' ? true : false,
      checklist_columns,
      static_column_values: staticRowData,
    };

    data.checklist_columns.forEach((column) => {
      if (!column.column_type) {
        error = true;
        SweetAlert('Please select column type for each column', 'error');
        return false;
      }
    });

    if (error) {
      return;
    }
    let res = await APIService.post(`/v0/ui/checklists/${campaignId}/create`, data);
    if (res.status == 200) {
      SweetAlert('Checklist created successfully', 'success');
      onBack()
    } else {
      SweetAlert('Booking Template updated successfully', 'success');
    }
  }

  const handleStaticColumnChange = (event, columnIndex) => {
    let rows = Object.assign({}, state.static_column_values);
    for (let i = 0; i < rows[columnIndex + 1].length; i++) {
      rows[columnIndex + 1][i].disabled = !event.target.checked;
    }
    setState({
      ...state,
      static_column_values: rows,
    });
  }

  const renderChecklistColumn = (column, columnIndex) => {
    const onColumnNameChange = (event) => {
      const newColumn = Object.assign({}, column, {
        column_name: event.target.value,
      });
      handleColumnChange(newColumn, columnIndex);
    };

    const onColumnTypeChange = (item) => {
      if (item.value !== 'TEXT') {
        let rows = Object.assign({}, state.static_column_values);
        if (rows[columnIndex + 1][0].disabled === false) {
          SweetAlert('Cannot change type for Static Columns', 'error');
          return;
        }
      }
      if (item.value === 'RADIO' || item.value === 'SELECT') {
        setState({
          ...state,
          showOptionModal: true,
          columnOptions: [''],
          columnInfo: {
            columnType: item,
            column,
            columnIndex,
          },
        });
        return;
      }
      const newColumn = Object.assign({}, column, {
        column_type: item,
      });
      handleColumnChange(newColumn, columnIndex);
    };
    const onRemove = () => {
      onColumnRemove(columnIndex);
    };

    return (
      <Box key={`col-${columnIndex}`} sx={{ mb: 2 }} width='389px'>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
        fullWidth
        placeholder="Column Name"
        value={column.column_name}
        onChange={onColumnNameChange}
        label="Column Name"
        InputProps={{
          sx: {
          '& input': {
            padding: '8px',
          },
          },
        }}
          InputLabelProps={{
          sx: {
          top: '-7px',
          },
        }}
        />
        <SearchableDropdown
        options={ColumnTypes}
        labelKey="label"
        valueKey="value"
        value={
          typeof column.column_type === 'object'
          ? column.column_type
          : getColumnOption(column.column_type)
        }
        onChange={onColumnTypeChange}
        label="Column Type"
        size="small"
        className="form-select"
        error={false}
        disabled={false}
  
        />

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {columnIndex > 1 ? (
          <Button variant="contained" size="small" color="primary" onClick={onRemove}>
          Remove column
          </Button>
        ) : null}
        {column.column_type &&
          (column.column_type.value === 'RADIO' || column.column_type.value === 'SELECT') ? (
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() =>
            onOpenOptionModal(
              column.column_options,
              column.column_type,
              column,
              columnIndex
            )
            }
          >
            Show Options
          </Button>
          ) : null}
        </Box>
      </Box>
      </Box>
    );
  }

  const handleSelectChecklist = (selectedChecklist) => {
    setState({
      ...state,
      selectedChecklist,
    });
  }

  const renderChecklistRow = (row, rowIndex) => {
    const onRemove = () => {
      onRowRemove(rowIndex);
    };
    let static_value = Object.assign({}, state.static_column_values);
    return (
      <Box
        key={`row-${rowIndex}`}
        sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mb: 2 }}
      >
        {state.checklist_columns.map((column, columnIndex) => {
          const cell = static_value[columnIndex + 1]?.[rowIndex];
          const value = cell?.cell_value || '';
          const isDisabled = cell?.disabled ?? true;

          return (
            <Box
              key={`row-${rowIndex}-column-${columnIndex}`}
              sx={{ flex: '1 1 200px', p: 1, alignSelf:'baseline' }}
            >
              <Box className="createform__form__inline" sx={{display:'flex', flexDirection:{xs:'column', sm:'row', gap:'12px', overflowX:'auto'}}}>
                <TextField
                  fullWidth
                  placeholder="Static Data"
                  value={value}
                  onChange={(event) => handleRowChange(event, columnIndex, rowIndex)}
                  disabled={isDisabled}   
                  InputProps={{
                            sx: {
                            '& input': {
                              padding: '8px',
                            },
                            },
                          }}
                            InputLabelProps={{
                            sx: {
                            top: '-7px',
                            },
                      }}
                />

                {columnIndex !== 0 && (
                  <Box sx={{ display: { xs: 'column', sm: 'flex', md: 'flex' }, alignItems: 'center', mt: 1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={(event) => handleStaticColumnChange(event, columnIndex)}
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Static Data
                          <em style={{ marginLeft: 4, fontSize: '0.75rem', color: '#888' }}>
                            (Field entered in static column cannot be changed later)
                          </em>
                        </Typography>
                      }
                      sx={{ alignItems: 'flex-start' }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          );
        })}
        {rowIndex > 0 && (
          <Box sx={{ ml: 1 }}>
            <IconButton
              color="error"
              onClick={onRemove}
              aria-label="Remove Row"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding:"5px" }}>
      <Box
        sx={{
          mb: 2,
          height: '73px',
          background: '#6c7eff',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontSize: '28px', paddingTop: '5px',paddingBottom: '5px' }} variant="h5" gutterBottom>
          Create Checklist Form
        </Typography>
      </Box>


      <Box sx={{ overflowX: 'auto' }} component="form" onSubmit={onSubmit}>
        <Box sx={{ mb: 0 , mt:2}}>
          {/* <FormControl fullWidth>
            <InputLabel>Select from existing checklist templateType</InputLabel>
            <Select
              value={state.selectedChecklist || ''}
              onChange={handleSelectChecklist}
              required
              label="Select from existing checklist templateType"
            >
              {state.existingChecklistOptions.map((option, index) => (
                <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <SearchableDropdown
            options={state.existingChecklistOptions}
            label={
              <Typography component="span" sx={{ position: 'relative', top: '-1px' }}>
                Select from existing checklist templateType<span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            value={state.selectedChecklist}
            onChange={handleSelectChecklist}
            labelKey="label"
            valueKey="value"
            error={false}
            errorMessage="This field is required"
            disabled={false}
            sx={{ mb: 2, paddingTop: '0px' }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <TextField 
            label={
              <Typography component="span">
                Enter Name For Checklist FormType<span style={{ color: 'red' }}>*</span>
              </Typography>
            }
  
            name="checklist_name"
            fullWidth
            value={state.checklist_name}
            InputProps={{
                sx: {
                  '& input': {
                    padding: '8px',
                  },
                },
              }}
                 InputLabelProps={{
          sx: {
          top: '-7px',
          },
        }}
            onChange={handleInputChange}
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.is_template}
                name="is_template"
                onChange={handleInputChange}
              />
            }
            label="Is it template?"
          />
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {state.checklist_columns.map(renderChecklistColumn)}
        </Box>
        
        {state.static_column_values['1'].map(renderChecklistRow)}

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' , flexDirection:{xs:'column', sm:'row'}, mt: 2 }}>
          <Button variant="contained" size='small' color="primary" onClick={onAddRow}>
            Add Row
          </Button>
          <Button
            variant="contained"
            color="primary"
            size='small'
            onClick={onAddColumn}
            disabled={state.isMaxColumnsReached}
          >
            Add Column
          </Button>
          <Button variant="contained" size='small' color="primary" type="submit">
            Submit
          </Button>
          <Button variant="contained" size='small' color="primary" onClick={onBack}>
            Back
          </Button>
        </Box>

        {state.isMaxColumnsReached && (
          <Typography color="primary" sx={{ mt: 2 }}>
            Sorry! You can add a maximum of {MAX_COLUMNS} columns
          </Typography>
        )}
      </Box>

      <OptionModal
        showOptionModal={state.showOptionModal}
        onCancel={onCancelOptionModal}
        onSubmit={onSubmitOptionModal}
        options={state.columnOptions}
        columnInfo={state.columnInfo}
      />
    </Box>
  );
}
export default CreateChecklistTemplate;